export default {"src":"/_next/static/image/public/images/ic_404_error.9e3d0fc06f084e81cc56a86ae9a0b7fb.svg","height":271,"width":210};